import { gsap, TimelineMax } from "../../../../gsap"
import { SVGHeart } from "./heart"
const { random } = gsap.utils

const emojiReactionAnimation = (color: string, target: string) => {
  let element = document.getElementById(target)

  const tl = new (TimelineMax as any)()

  const emojiElement: HTMLParagraphElement = document.createElement("p")
  /* Always heart for compatibility, can be passed in 
  in future to make this function animate any emoji type */
  emojiElement.innerHTML = SVGHeart(color)
  emojiElement.style.pointerEvents = "none"

  const startParams = {
    opacity: 1,
    position: "absolute",
    width: `${element.clientWidth}px`,
    height: `${element.clientHeight}px`,
    top: `${element.getBoundingClientRect().top}px`,
    left: `${element.getBoundingClientRect().left}px`
  }

  const rotation = random(-30, 30)
  const randomOffset = Math.floor(Math.random() * 20)
  const distanceToTop = element.getBoundingClientRect().top
  const pixelsPerSecond = 200
  const duration = distanceToTop / pixelsPerSecond

  const endParams = {
    top: 0,
    left: `${element.getBoundingClientRect().left - randomOffset}px`,
    opacity: 0,
    duration,
    rotation,
    x: random(-20, -60),
    height: `${random(4, 72)}px`,
    width: `${random(4, 72)}px`,
    ease: "out"
  }

  document.body.appendChild(emojiElement)

  tl.fromTo(emojiElement, startParams, endParams).call(() =>
    emojiElement?.parentNode?.removeChild(emojiElement)
  )
}

export default emojiReactionAnimation
